import "./styles/player.scss";
import merge from "lodash/merge";
import * as serviceWorker from "./serviceWorker";
import { attachScoreListeners } from "./player/utils/score";
import { addLessonSidebarHook } from "./player/utils/hooks";
import {
  ATTRIBUTE_ACTIVITY,
  ACTIVITY_STATES_KEY,
  INIT_ACTIVITIES,
  TOOLTIP_CONTAINER
} from "./common/constants/attributes";
import { isDevelopment } from "./common/constants/env";

class App {
  static async bootstrap() {
    const app = new App();
    app.attachServiceWorker();
    app.appendGlobalContainers();
    addLessonSidebarHook();
    attachScoreListeners();

    const locale = await app.loadLocale().catch(() => app.loadLocale("en"));
    await app.bootstrapActivies(locale);
  }

  loadLocale(lang) {
    return import(
      /* webpackChunkName: "[request]" */ `./player/i18n/${lang ||
        document.documentElement.getAttribute("lang") ||
        navigator.language ||
        navigator.userLanguage}`
    );
  }

  attachServiceWorker() {
    if (isDevelopment) {
      serviceWorker.unregister();
    } else {
      serviceWorker.register();
    }
  }

  appendGlobalContainers() {
    const tooltipContainer = document.createElement("div");

    tooltipContainer.id = TOOLTIP_CONTAINER;
    tooltipContainer.style.cssText = "position: absolute; z-index: 9999";

    document.body.appendChild(tooltipContainer);
  }

  async bootstrapActivies(locale) {
    const activityContainers = Array.from(
      document.querySelectorAll("*[" + ATTRIBUTE_ACTIVITY + "]")
    );

    for (let node of activityContainers) {
      const stateId = node.getAttribute(ATTRIBUTE_ACTIVITY);
      const state = window[ACTIVITY_STATES_KEY][stateId];

      if (state) {
        const activity = await import(
          /* webpackChunkName: "[request]" */ `./player/activities/${state.type}/index`
        );

        activity.bootstrap(
          node,
          state,
          new Proxy(locale, {
            get(target, prop) {
              return target.common && target[prop]
                ? merge({}, target.common, target[prop])
                : target[prop];
            }
          })
        );
      }
    }
  }
}

if (window.manualControl) {
  window[INIT_ACTIVITIES] = App.bootstrap;
} else {
  document.addEventListener("DOMContentLoaded", App.bootstrap);
}
